import React, {Component} from 'react';
import FilterImage from '@/assets/icons/filter.png';
import FilterActiveImage from '@/assets/icons/filter-active.png';
import {fetchDocPrices, fetchDocTitl} from '@/store/api/doctor';

import './index.less';

class GstFilter extends Component {
  constructor(props) {
    super(props);
   const {price,title,property,number} =props.defaultValue||{}
    this.state = {
      isActive: false,
      honorArr: [],
      priceArr: [],
      numArr: [
        {val: 0, txt: '全部'},
        {val: 1, txt: '有号源'},
        // {val: 2, txt: '无号源'},
      ],
      propertyArr: [
        {val: 0, txt: '全部'},
        {val: 1, txt: '分院就诊'},
        {val: 2, txt: '视频问诊'},
      ],
      honorIdxArr: title?(title.length?title:[0]):[],
      priceIdxArr: price?(price.length?price:[0]):[],
      numIdx: number??'',
      propertyIdx: property??(+props.video || ''),
    };
  }

  componentDidMount() {
    this.requestDocPrice();
    this.requestDocTitl();
  }

  async requestDocPrice() {
    const res = await fetchDocPrices();
    if (res.status == 0) {
      this.setState({
        priceArr: [{name: '全部', id: 0}, ...res.data],
      });
    }
  }

  async requestDocTitl() {
    const res = await fetchDocTitl();
    if (res.status == 0) {
      this.setState({
        honorArr: [{name: '全部', id: 0}, ...res.data],
      });
    }
  }

  toggleModal(data) {
    this.props.onToggle(data);
  }

  onSelectClick(key) {
    this.props.onToggle(key);
  }

  onSelectHonor(idx) {
    let {honorIdxArr} = this.state;
    if (honorIdxArr.includes(idx)) {
      const a_idx = honorIdxArr.findIndex((item) => item === idx);
      honorIdxArr.splice(a_idx, 1);
    } else {
      if (idx === 0) {
        honorIdxArr = [0];
      } else {
        honorIdxArr.push(idx);
        // 针对全部处理
        if (honorIdxArr.includes(0)) {
          honorIdxArr.splice(0, 1);
        }
      }
    }

    this.setState({
      honorIdxArr: honorIdxArr.sort(),
    });
  }

  onSelectPrice(idx) {
    let {priceIdxArr} = this.state;
    if (priceIdxArr.includes(idx)) {
      const a_idx = priceIdxArr.findIndex((item) => item === idx);
      priceIdxArr.splice(a_idx, 1);
    } else {
      if (idx === 0) {
        priceIdxArr = [0];
      } else {
        priceIdxArr.push(idx);
        // 针对全部处理
        if (priceIdxArr.includes(0)) {
          priceIdxArr.splice(0, 1);
        }
      }
    }

    this.setState({
      priceIdxArr: priceIdxArr.sort(),
    });
  }

  onSelectNum(idx) {
    this.setState({
      numIdx: idx,
    });
  }

  onSelectProperty(idx) {
    this.setState({
      propertyIdx: idx,
    });
  }

  onOk() {
    const {honorArr, honorIdxArr, priceArr, priceIdxArr, numArr, numIdx, propertyArr, propertyIdx} = this.state;
    let title = honorIdxArr
      .map((item) => honorArr[item].id)
      .filter((item) => !!item)
      .sort();
    let price = priceIdxArr
      .map((item) => priceArr[item].id)
      .filter((item) => !!item)
      .sort();
    let number = (numIdx && numArr[numIdx].val) || 0;
    let video = (propertyIdx && propertyArr[propertyIdx].val) || 0;
    console.log(title, price, number);
    this.toggleModal(-1);
    if (this.props.onSelect) this.props.onSelect({title, price, number, property: video});
  }

  onReset() {
    this.setState({
      honorIdxArr: [],
      priceIdxArr: [],
      numIdx: '',
      propertyIdx: '',
    });
  }

  render() {
    const {isShow} = this.props;
    const {selectIdx, isActive, honorArr, priceArr, numArr, propertyArr, honorIdxArr, priceIdxArr, numIdx, propertyIdx} = this.state;
    const {key} = this.props.data || {};

    return (
      <div className="gst-filter">
        <div className="gst-filter-view" onClick={() => this.onSelectClick(key)}>
          <img alt="" src={isActive ? FilterImage : FilterActiveImage} />
        </div>
        {isShow && (
          <div className="gst-filter-wrap">
            <div className="gst-filter-mask" onClick={() => this.toggleModal()} />
            <div className="pos-wrap">
              <div className="gst-filter-content">
                <div className="mpanel">
                  <div className="mpanel-title">
                    看诊方式<span>(单选)</span>
                  </div>
                  <div className="mpanel-content">
                    {propertyArr.map((item, idx) => (
                      <span key={idx} className={propertyIdx === idx ? 'active' : ''} onClick={() => this.onSelectProperty(idx, item)}>
                        {item.txt}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mpanel honor">
                  <div className="mpanel-title">
                    医生荣誉/职称<span>(多选)</span>
                  </div>
                  <div className="mpanel-content">
                    {honorArr.map((item, idx) => (
                      <span key={idx} className={honorIdxArr.includes(idx) ? 'active' : ''} onClick={() => this.onSelectHonor(idx, item)}>
                        {item.name}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mpanel">
                  <div className="mpanel-title">
                    按诊金筛选<span>(多选)</span>
                  </div>
                  <div className="mpanel-content">
                    {priceArr.map((item, idx) => (
                      <span key={idx} className={priceIdxArr.includes(idx) ? 'active' : ''} onClick={() => this.onSelectPrice(idx, item)}>
                        {item.name}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mpanel nums">
                  <div className="mpanel-title">
                    有无号源<span>(单选)</span>
                  </div>
                  <div className="mpanel-content">
                    {numArr.map((item, idx) => (
                      <span key={idx} className={numIdx === idx ? 'active' : ''} onClick={() => this.onSelectNum(idx, item)}>
                        {item.txt}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="btns">
                <div className="btn reset" onClick={() => this.onReset()}>
                  重置
                </div>
                <div className="btn ok" onClick={() => this.onOk()}>
                  确认
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default GstFilter;
